/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInDid: core.serialization.ObjectSchema<serializers.NotInDid.Raw, Truvity.NotInDid> =
    core.serialization.object({
        values: core.serialization.list(core.serialization.string()),
    });

export declare namespace NotInDid {
    export interface Raw {
        values: string[];
    }
}
